/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Limits_Starter_AddonsInputs */



/**
* | output |
* | --- |
* | "From €3.50/mo" |
*
* @param {Compare_Limits_Starter_AddonsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compare_limits_starter_addons = /** @type {((inputs?: Compare_Limits_Starter_AddonsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Limits_Starter_AddonsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ab €3,50/Mo.")
	return /** @type {LocalizedString} */ ("From €3.50/mo")
});